<template>
  <v-container>
    <h1>Logg ut</h1>

    <v-card>
      <v-form ref="form" lazy-validation @submit.prevent="submit">
        <p>Logge ut ?</p>

        <v-card-actions>
          <v-btn type="submit" color="success">
            <v-icon left> mdi-content-save </v-icon>
            Logg ut
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "Logout",

  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        await this.$store.dispatch("logout");

        this.$router.push({
          name: "login",
        });
      }
    },
  },
};
</script>
